module.exports = __webpack_public_path__ + "static/media/saxenda-grey-bg.3b21d58a.png";